<template>
  <div id="main">
    <answer
      @close="close"
      :mode="mode"
      @complete="complete"
      v-show="step == 2"
      ref="answer"
    ></answer>
  </div>
</template>
<script>
import Home from "./home";
import choose from "./choose";
import answer from "./answer";
import result from "./result";
import loginDialog from "../dialog/login/index";
export default {
  props: ["questions"],
  components: {
    Home,
    choose,
    answer,
    result,
  },
  data() {
    return {
      step: 2,
      remainTimes: 0,
      mode: "",
      audioSource: "",
      currectCommit: 0,
      play: false,
      unLogin: true,
    };
  },
  methods: {
    setQuestions(questions){
      this.$refs.answer.setQuestions(questions);
    },
    audioPlay() {
      this.play = true;
      document.getElementById("myaudio").play();
    },
    playToggle() {
      if (this.play) {
        this.play = false;
        document.getElementById("myaudio").pause();
      } else {
        this.play = true;
        document.getElementById("myaudio").play();
      }
    },
    again() {
      this.step = 0;
      this.getRemainTimes();
      /* 重置答题部分前端数据 */
      this.$refs.answer.resetAnswer();
    },
    startAnswer() {
      this.choose();
    },
    close() {
      this.$emit("close");
    },
    complete({ currectCommit, topicRecordId }) {
      if (currectCommit == -1) {
        /* 说明没有次数想访问结果页 */
        this.step = 2;
        // this.$refs.result.getRemainTimes();
        // this.$refs.result.toprank();
        // this.$refs.result.myOwnInfo(true);
        return;
      }
      this.currectCommit = currectCommit;
      this.step = 3;
      this.$refs.result.getRemainTimes();
      this.$refs.result.myOwnInfo(false, topicRecordId);
    },
  },
};
</script>
<style lang='less' scoped="true">
.bgm {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 30px;
  z-index: 2;
}
.rotate {
  animation: rotate linear 2s infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
#myaudio {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  display: none;
}
</style>